// Savings Calculator Code

// Declare HTMLElemets
let CalculateButton: HTMLElement;
let ClearButton: HTMLElement;
let WaterRate: HTMLInputElement;
let wrError: HTMLElement;
let NumberOfBeds: HTMLInputElement;
let nbError: HTMLElement;
let Before2000: HTMLInputElement;
let After2000: HTMLInputElement;
let Results: HTMLElement;
let GallonsSaved: HTMLElement;
let DollarsSaved: HTMLElement;

// Declare Constants
const pre: number = 15;
const post: number = 8;
const pre2kb: number = 3.5;
const pre2ka: number = 1.6;
const post2kb: number = 1.6;
const post2ka: number = 0.9;
const days: number = 365;

function Initialize() {
    CalculateButton = document.getElementById("CalculateButton");
    ClearButton = document.getElementById("ClearButton");
    WaterRate = document.getElementById("WaterRate") as HTMLInputElement;
    wrError = document.getElementById("wrError");
    NumberOfBeds = document.getElementById("NumberOfBeds") as HTMLInputElement;
    nbError = document.getElementById("nbError");
    Before2000 = document.getElementById("Before2000") as HTMLInputElement;
    After2000 = document.getElementById("After2000") as HTMLInputElement;
    Results = document.getElementById("Results");
    GallonsSaved = document.getElementById("GallonsSaved");
    DollarsSaved = document.getElementById("DollarsSaved");

    CalculateButton.onclick = Calculate;
    ClearButton.onclick = ClearAll;
}

function ClearAll() {
    ClearResults();
    ClearValues();
}

function ClearResults() {
    GallonsSaved.innerHTML = "";
    DollarsSaved.innerHTML = "";

    wrError.style.display = "none";
    nbError.style.display = "none";

    Results.style.display = "none";
}

function ClearValues() {
    WaterRate.value = "";
    NumberOfBeds.value = "";
    Before2000.checked = true;
    After2000.checked = false;
}

function Calculate() {
    const wr: number = parseFloat(WaterRate.value) || 0;
    const nb: number = parseFloat(NumberOfBeds.value) || 0;
    let gb: number;
    let ga: number;

    // Clear any previous results or errors
    ClearResults();

    // Check to make sure a valid value was given for the water rate
    if (wr === null || wr === 0) {
        // Display error and exit function
        wrError.style.display = "inline";
        return;
    }

    // Check to make sure a valid value was given for the number of beds
    if (nb === null || nb === 0) {
        // Display error and exit function
        nbError.style.display = "inline";
        return;
    }

    // Check to see if facility was built before 2000 and calculate accordingly
    if (Before2000.checked === true) {
        gb = pre * pre2kb * nb * days;
        ga = post * pre2ka * nb * days;
    } else {
        gb = pre * post2kb * nb * days;
        ga = post * post2ka * nb * days;
    }

    // Display Results
    GallonsSaved.innerHTML = FormatToCommas(gb - ga);
    DollarsSaved.innerHTML = FormatToCurrency(((gb - ga) * wr) / 1000);

    // Show the results div
    Results.style.display = "block";
}

function FormatToCurrency(num: any) {
    num = Number(num.toString().replace(/\$|\,/g, ""));
    if (isNaN(num)) {
        num = "0";
    }
    const sign: boolean = (num === (num = Math.abs(num)));
    num = Math.floor(num * 100 + 0.50000000001);
    let cents: number = num % 100;
    num = Math.floor(num / 100).toString();
    if (cents < 10) {
        cents = 0 + cents;
    }
    for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + "," + num.substring(num.length - (4 * i + 3));
    }
    return (((sign) ? "" : "-") + "$" + num + "." + cents);
}

function FormatToCommas(num: any) {
    num = Number(num.toString().replace(/\$|\,/g, ""));
    if (isNaN(num)) {
        num = "0";
    }
    const sign: boolean = (num === (num = Math.abs(num)));
    num = Math.floor(num * 100 + 0.50000000001);
    let cents: number = num % 100;
    num = Math.floor(num / 100).toString();
    if (cents < 10) {
        cents = 0 + cents;
    }
    for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + "," + num.substring(num.length - (4 * i + 3));
    }
    return (((sign) ? "" : "-") + num + "." + cents);
}

// version: beta
// created: 2005-08-30
// updated: 2005-08-31
// mredkj.com
function extractNumber(obj: HTMLInputElement, decimalPlaces: number, allowNegative: boolean) {
    let temp = obj.value;

    // avoid changing things if already formatted correctly
    let reg0Str = "[0-9]*";
    if (decimalPlaces > 0) {
        reg0Str += "\\.?[0-9]{0," + decimalPlaces + "}";
    } else if (decimalPlaces < 0) {
        reg0Str += "\\.?[0-9]*";
    }
    reg0Str = allowNegative ? "^-?" + reg0Str : "^" + reg0Str;
    reg0Str = reg0Str + "$";
    const reg0 = new RegExp(reg0Str);
    if (reg0.test(temp)) {
        return true;
    }

    // first replace all non numbers
    const reg1Str = "[^0-9" + (decimalPlaces !== 0 ? "." : "") + (allowNegative ? "-" : "") + "]";
    const reg1 = new RegExp(reg1Str, "g");
    temp = temp.replace(reg1, "");

    if (allowNegative) {
        // replace extra negative
        const hasNegative = temp.length > 0 && temp.charAt(0) === "-";
        const reg2 = /-/g;
        temp = temp.replace(reg2, "");
        if (hasNegative) {
            temp = "-" + temp;
        }
    }

    if (decimalPlaces !== 0) {
        const reg3 = /\./g;
        const reg3Array = reg3.exec(temp);
        if (reg3Array != null) {
            // keep only first occurrence of .
            //  and the number of places specified by decimalPlaces or the entire string if decimalPlaces < 0
            let reg3Right = temp.substring(reg3Array.index + reg3Array[0].length);
            reg3Right = reg3Right.replace(reg3, "");
            reg3Right = decimalPlaces > 0 ? reg3Right.substring(0, decimalPlaces) : reg3Right;
            temp = temp.substring(0, reg3Array.index) + "." + reg3Right;
        }
    }

    obj.value = temp;
}

function blockNonNumbers(obj: HTMLInputElement, e: KeyboardEvent, allowDecimal: boolean, allowNegative: boolean) {
    let key;
    let isCtrl = false;
    let keychar;
    let reg;

    if (window.event) {
        key = e.keyCode;
        isCtrl = (window.event as KeyboardEvent).ctrlKey;
    } else if (e.which) {
        key = e.which;
        isCtrl = e.ctrlKey;
    }

    if (isNaN(key)) {
        return true;
    }

    keychar = String.fromCharCode(key);

    // check for backspace or delete, or if Ctrl was pressed
    if (key === 8 || isCtrl) {
        return true;
    }

    reg = /\d/;
    const isFirstN = allowNegative ? keychar === "-" && obj.value.indexOf("-") === -1 : false;
    const isFirstD = allowDecimal ? keychar === "." && obj.value.indexOf(".") === -1 : false;

    return isFirstN || isFirstD || reg.test(keychar);
}
